module.exports = __webpack_public_path__ + "static/media/icon-popular.463af1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/type-filters/icon-popular.svg
// module id = 1478
// module chunks = 0